import intersect from 'just-intersect';

/**
 * Checks for required privileges.
 */
export const hasPrivileges = (requiredPrivileges, privileges) =>
  intersect(privileges, requiredPrivileges).length ===
  requiredPrivileges.length;
